import AgoraRTC, { AgoraRTCProvider } from "agora-rtc-react";
import TeleLayout from "./_layout";
import { MeetingProvider } from "./context/MeetingContext";
import { UserProvider } from "./context/UserContext";
import { SocketProvider } from "./context/SocketContext";
import { io } from "socket.io-client";
import { useEffect } from "react";
import { useLoaderData } from "react-router-dom";
import { getToken } from "../../../utils/token";
import instance from "../../../axios/instance";

export const agoraLoader = async () => {
  const token = getToken();
  const res = await instance.get("/doctor/billing/plan/active", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res.data;
};

export default function AgoraClient() {
    const plan = useLoaderData();
  // In video call, set mode to "rtc"
  // const client = AgoraRTC.createClient({ mode: "rtc", codec: "vp8" });

  return (
    <UserProvider>
      {/* <SocketProvider> */}
      {/* <AgoraRTCProvider client={client}> */}
      <MeetingProvider>
        <TeleLayout plan={plan} />
      </MeetingProvider>
      {/* </AgoraRTCProvider> */}
      {/* </SocketProvider> */}
    </UserProvider>
  );
}
